/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum JahresgespraechStatus {
    Abgebrochen = 'Abgebrochen',
    Angefragt = 'Angefragt',
    Erinnert = 'Erinnert',
    Abgelaufen = 'Abgelaufen',
    BereitZurUeberpruefung = 'BereitZurUeberpruefung',
    Abgeschlossen = 'Abgeschlossen'
  }

    export const JahresgespraechStatusTranslocoMap: Record<JahresgespraechStatus, string> = {
    [JahresgespraechStatus.Abgebrochen]: 'jahresgespraechStatus.abgebrochen',
    [JahresgespraechStatus.Angefragt]: 'jahresgespraechStatus.angefragt',
    [JahresgespraechStatus.Erinnert]: 'jahresgespraechStatus.erinnert',
    [JahresgespraechStatus.Abgelaufen]: 'jahresgespraechStatus.abgelaufen',
    [JahresgespraechStatus.BereitZurUeberpruefung]: 'jahresgespraechStatus.bereitZurUeberpruefung',
    [JahresgespraechStatus.Abgeschlossen]: 'jahresgespraechStatus.abgeschlossen',
    };

    export const JahresgespraechStatusOptions = [
  { value: JahresgespraechStatus.Abgebrochen, labelKey: 'jahresgespraechStatus.abgebrochen' },
  { value: JahresgespraechStatus.Angefragt, labelKey: 'jahresgespraechStatus.angefragt' },
  { value: JahresgespraechStatus.Erinnert, labelKey: 'jahresgespraechStatus.erinnert' },
  { value: JahresgespraechStatus.Abgelaufen, labelKey: 'jahresgespraechStatus.abgelaufen' },
  { value: JahresgespraechStatus.BereitZurUeberpruefung, labelKey: 'jahresgespraechStatus.bereitZurUeberpruefung' },
  { value: JahresgespraechStatus.Abgeschlossen, labelKey: 'jahresgespraechStatus.abgeschlossen' },
    ];

